// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-settings .briq-form-element,\n.email-settings h2 {\n  margin-bottom: 24px;\n}\n.email-settings .translation-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n}\n.email-settings .translation-header .translation-button {\n  margin-bottom: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
